<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left m-0">
            Sincronizando Pontos
          </h4>

          <div class="tab-content" id="pills-tabContent" style="min-height: 100px;">
            <div v-show="itemMenu == 1" class="tab-pane fade" :class="itemMenu == 1 ? 'show active' : ''">
              <div class="row justify-content-center mt-2">

                <div class="row">
                  <!-- <base-input name="nome" class="col-sm-6" @keypress="resetForm()" required placeholder="Tipo de sincronização" v-model.trim="model.tipoSync"
                      :class="error.nome === true ? 'has-danger' : ''" :error="getError('nome')" /> -->
                  <div class="col-sm-6">
                    <div><p class="text-start">Tipo de Sincronização</p></div>
                    <div class="d-flex">
<!--                       <base-radio name="0" class="mb-3" v-model="model.tipoSync">
                        Sinc. por data
                      </base-radio> -->

                      <base-radio name="0" class="mb-3 ms-2" v-model="model.tipoSync">
                          Sinc. por NSR
                      </base-radio>

                      <base-radio name="1" class="mb-3 ms-2" v-model="model.tipoSync">
                          Sinc. Completa
                      </base-radio>
                    </div>
                  </div>

                  <!-- <div class="col-sm-6">
                    <div><p class="text-start">Layout do Arquivo</p></div>
                    <div class="d-flex">
                      <base-radio name="1510" class="mb-3" v-model="model.portaria">
                        Portaria 1510
                      </base-radio>
                      <base-radio name="671" class="mb-3 ms-2" v-model="model.portaria">
                        Portaria 671
                      </base-radio>
                    </div>
                  </div> -->
                  <!-- <p class="text-muted small">Obs.: marcar o tipo de AFD (portaria) é opcional. Caso não seja informado, o sistema detectará o layout automaticamente.</p> -->
                </div>

<!--                 <div class="row" v-if="model.tipoSync == '0'">
                  <div class="col-md-6 text-left">
                    <base-input label="Data" type="date" placeholder="dia/mês/ano" v-model="model.dataInicio">
                    </base-input>
                  </div>
                </div> -->

                <div class="text-start" v-if="model.tipoSync == '0'">
                  <base-input class="col-sm-6" type="text" label="Sincronização por NSR" placeholder="Sincronização por NSR" v-model="model.nsr"/>
                </div>

                <div class="text-start" v-else>
                  <div class="col-sm-6"><p><strong>Sincronização Completa</strong></p></div>
                </div>
              </div>
            </div>
          </div>


          <div class="row d-flex justify-content-end mt-3">
            <div class="col-sm-3 offset-6">
              <base-button block type="success" @click="gerarArquivo()" :disabled="validateForm()">Sincronizar Pontos</base-button>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="vld-parent">
      <loading :active.sync="isLoading" :can-cancel="false" loader="spinner" color="#35a887" :is-full-page="true">
      </loading>
    </div>
  </div>
</template>
<script>
import { Card, BasePagination, BaseInput, BaseRadio } from "@/components/index";
import Loading from "vue-loading-overlay";
import { SimpleWizard, WizardTab } from "@/components";
import ContribuicaoSindical from "../../pages/Forms/Wizard/Funcionarios/ContribuicaoSindical.vue";
import DadosPessoais from "../../pages/Forms/Wizard/Funcionarios/DadosPessoais.vue";
import estadosjs from "../../pages/Forms/Wizard/Funcionarios/estados";
import cidadesjs from "../../pages/Forms/Wizard/Funcionarios/cidades.json";
import Foto from "../../pages/Forms/Wizard/Funcionarios/Foto.vue";
import DadosEmpregaticios from "../../pages/Forms/Wizard/Funcionarios/DadosEmpregaticios.vue";
import Documentacao from "../../pages/Forms/Wizard/Funcionarios/Documentacao.vue";
import Estrangeiro from "../../pages/Forms/Wizard/Funcionarios/Estrangeiro.vue";
import Motorista from "../../pages/Forms/Wizard/Funcionarios/Motorista.vue";

import FirstStep from "../../pages/Forms/Wizard/FirstStep.vue";
import SecondStep from "../../pages/Forms/Wizard/SecondStep.vue";
import ThirdStep from "../../pages/Forms/Wizard/ThirdStep.vue";

import ModalRecFacialV2 from "../../pages/Pages/RegistrarPontoFuncionario/ModalRecFacialV2.vue";

import swal from "sweetalert2";
import Modal from "@/components/Modal.vue";

const https = require('https');

const httpsAgent = new https.Agent({
    rejectUnauthorized: false,
});

export default {
  data() {
    return {

      fileName: '', 
      isLoading: false,
      title: "Novo Equipamento",
      wizardModel: {},

      itemMenu: 1,

      file: null,
      estados: estadosjs,
      estadoSelecionado: "",
      cidades: [],
      modelos: [
          {
              "ID": "1",
              "Nome": "REP IDClass (REP-C)",
          },
          {
              "ID": "2",
              "Nome": "IDClass 373 (REP-A)",
          },
          {
              "ID": "3",
              "Nome": "IDFace/ IDFlex (Coletor REP-P)",
          },
          {
              "ID": "4",
              "Nome": "Outros",
          }
      ],

      cpf: "",

      listDepartamentos: [],
      listTiposBatidas: [
        {
          id: 1,
          descricao: 'Facial'
        },
        {
          id: 2,
          descricao: 'Biometria (dedo)'
        },
        {
          id: 3,
          descricao: 'Todos'
        }
      ],
      listFuncoes: [],
      listEmpregadores: [],
      descricaoCadFunc: "",
      descricaoCadDep: "",
      descricaoCadDep: "",
      modalCadastrarFunc: false,
      modalCadastrarDep: false,
      sinc_or_create: "Sincronizando",

      fotoTirada: false,
      dadosRelogio: {
        ip: "",
        session: "",
        dadosRelogio: "",
        id_empregador: "",
        modelo: "",
      },

      model: {
        tipoSync: "0",
        portaria: "",
        dataInicio: "",
        nsr: "",
      },

      sendFoto: "",
    };
  },
  components: {
    Modal,
    Card,
    BasePagination,
    BaseInput,
    BaseRadio,
    SimpleWizard,
    WizardTab,
    ContribuicaoSindical,
    DadosEmpregaticios,
    DadosPessoais,
    Foto,
    Loading,
    Documentacao,
    Estrangeiro,
    Motorista,
    FirstStep,
    SecondStep,
    ThirdStep,
    ModalRecFacialV2,
  },

  mounted() {
    this.carregaDadosRelogio(this.$route.params.id);
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },


    validateForm(){
      // Sincronização por NSR: exige tanto portaria quanto nsr
      if (this.model.tipoSync === "0") {
        // bloqueia (true) se algum dos dois estiver ausente
        return !this.model.nsr;
      }
      // Sincronização completa (arquivo): portaria opcional
      return false; // nunca bloqueia
    },

    gerarArquivo(){
      this.isLoading = true;
       if (this.model.tipoSync == "0") {
        this.buscarArquivoNsrTipo();
      } else {
        this.buscarArquivoCompletoTipo();
      }
    },

    async buscarArquivoCompletoTipo() {
      if(this.dadosRelogio.modelo == "IDFace/ IDFlex (Coletor REP-P)") {
        this.buscarArquivoCompletoIdFace();
      } else {
        this.buscarArquivoCompleto();
      }
    },

    carregaDadosRelogio(id){
      this.isLoading = true;
      let th = this;
      let form = {
        "setDB": this.$cookies.get("db"),
        "id": id
      };
      this.axios
        .post("/api/relogio/listarRelogios/id", form)
        .then((response) => {
          const {ip, sessao, id_empregador, modelo, porta} = response.data.data.dados[0];
          this.dadosRelogio.ip = ip;
          this.dadosRelogio.porta = porta;
          this.dadosRelogio.session = sessao;
          this.dadosRelogio.id_empregador = id_empregador;
          this.dadosRelogio.modelo = modelo;
          th.isLoading = false;
        })
        .catch((err) => {
          th.isLoading = false;
        });
        th.isLoading = false;
    },

    async buscarArquivoCompletoIdFace() {
        let th = this;
        let form;
        if(this.model.portaria == '671') {
          form = {
            "mode":  Number(`${this.model.portaria}`),
          }
        } else {
          form = {
          }
        }
        
        this.axios.post(`https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/export_afd.fcgi?session=${this.dadosRelogio.session}`,
        form,
        { httpsAgent: httpsAgent }
        )
        .then((res) => {
          th.file = res.data;
          th.sincronizarArquivo();
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao sincronizar com o relógio!",
            "error"
          );
        });
    },

    async buscarArquivoCompleto() {
        let th = this;
        let form;
        if(this.model.portaria == '671') {
          form = {
            "mode":  Number(`${this.model.portaria}`),
            "session": this.dadosRelogio.session,
          }
        } else {
          form = {
            "session": this.dadosRelogio.session,
          }
        }
        
        this.axios.post(`https://${this.dadosRelogio.ip}/get_afd.fcgi`,
        form,
        { httpsAgent: httpsAgent }
        )
        .then((res) => {
          th.file = res.data;
          th.sincronizarArquivo();
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao sincronizar com o relógio!",
            "error"
          );
        });
    },

    async sincronizarArquivo(){
      let th = this;
      let form = {
        "setDB": th.$cookies.get("db"),
        "id_empregador": th.dadosRelogio.id_empregador,
        "file": th.file,
        "modelo": th.dadosRelogio.modelo,
      };
      // opcional: enviar tipoAfd (portaria) se houver valor selecionado
      if (th.model && th.model.portaria) {
        form.tipoAfd = th.model.portaria;
      } else {
        // avisa ao usuário que o backend fará a detecção automática
        th.showSwal(
          "auto-close",
          "Info",
          "Tipo AFD (portaria) não informado. O sistema detectará o layout automaticamente.",
          "info",
        );
      }
      
      await this.axios.post("/api/sincronizando/pontosCompleto", form)
      .then(async (res) => {
        if (res.data.status == 'success') {
          th.showSwal(
            "auto-close",
            "Sucesso",
            `${res.data.message}`,
            "success"
          );
        } else {
          th.showSwal(
            "auto-close",
            "Erro",
            `${res.data.err}`,
            "error"
          );
        }
      })
      .catch((err) => {
        th.isLoading = false;
        th.showSwal(
          "auto-close",
          "Erro",
          "Ocorreu algum erro ao sincronizar os pontos por arquivo!",
          "error"
        );

      }).finally(() => {
        th.isLoading = false;
        setTimeout(() => {
              th.$router.push("/controlId");
        }, 3000);
      });
    },

    async buscarArquivoNsrTipo() {
      if(this.dadosRelogio.modelo == "IDFace/ IDFlex (Coletor REP-P)") {
        this.buscarArquivoNsrIdFace();
      } else {
        this.buscarArquivoNsr();
      }
    },

    buscarArquivoNsrIdFace(){
      this.isLoading = true;
      let th = this;
      let form;

      if(this.model.portaria == '671') {
        form = {
          "mode":  Number(`${this.model.portaria}`),
          "initial_nsr": Number(`${this.model.nsr}}`)
        }
      } else {
        form = {
          "initial_nsr": Number(`${this.model.nsr}`)
        }
      }
        
      this.axios.post(`https://${this.dadosRelogio.ip}:${this.dadosRelogio.porta}/export_afd.fcgi?session=${this.dadosRelogio.session}`,
      form,
      { httpsAgent: httpsAgent }
      )
      .then((res) => {
        if (res.data) {
          th.file = res.data;
          th.sincronizarArquivo();
        } else {
          th.showSwal(
          "auto-close",
          "Erro",
          "Não exite ponto nesse intervalo!",
          "error"
        );
        }
      })
      .catch((err) => {
        th.isLoading = false;
        th.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar com o relógio!",
          "error"
        );
      });
    },

    buscarArquivoNsr(){
      this.isLoading = true;
      let th = this;
      let form;

      if(this.model.portaria == '671') {
        form = {
          "mode":  Number(`${this.model.portaria}`),
          "session": this.dadosRelogio.session,
          "initial_nsr": Number(`${this.model.nsr}}`)
        }
      } else {
        form = {
          "session": this.dadosRelogio.session,
          "initial_nsr": Number(`${this.model.nsr}`)
        }
      }
        
      this.axios.post(`https://${this.dadosRelogio.ip}/get_afd.fcgi`,
      form,
      { httpsAgent: httpsAgent }
      )
      .then((res) => {
        if (res.data) {
          th.file = res.data;
          th.sincronizarArquivo();
        } else {
          th.showSwal(
          "auto-close",
          "Erro",
          "Não exite ponto nesse intervalo!",
          "error"
        );
        }
      })
      .catch((err) => {
        th.isLoading = false;
        th.showSwal(
          "auto-close",
          "Erro",
          "Erro ao sincronizar com o relógio!",
          "error"
        );
      });
    },

    verifyDisabled() {
      if (
        !this.model.nome ||
        !this.model.email ||
        !this.model.cpf ||
        !this.model.funcao ||
        !this.model.departamento ||
        !this.sendFoto
      ) {
        return true;
      } else {
        return false;
      }
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    statusfoto(event) {
      this.sendFoto = event;
    },

    controlarMenu(valor) {
      console.log('valor', valor)
      //validar campos de acordo com o menu selecionado
      const alterarValor = (valor) => {
        if (valor === -1 && this.itemMenu > 1) {
          this.itemMenu -= 1;
        } else if (valor === 1 && this.itemMenu < 5) {
          this.itemMenu += 1;
        }
      };

      switch (this.itemMenu) {
        case 1:
          if (!this.model.nome || this.model.nome === "")
            this.error.nome = true;
          else this.error.nome = false;

          if (!this.model.email || this.model.email === "")
            this.error.email = true;
          else this.error.email = false;

          if (this.model.nome !== "" && this.model.email !== "") {
            alterarValor(valor);
          }
          break;
        case 2:
          if (!this.model.cpf || this.model.cpf === "") this.error.cpf = true;
          else this.error.cpf = false;

          if (this.model.cpf !== "") {
            alterarValor(valor);
          }
          break;
        case 3:
          if (!this.model.funcao || this.model.funcao === "")
            this.error.funcao = true;
          else this.error.funcao = false;

          if (!this.model.departamento || this.model.departamento === "")
            this.error.departamento = true;
          else this.error.departamento = false;

          if (!this.model.tipo_batida || this.model.tipo_batida === "")
            this.error.tipo_batida = true;
          else this.error.tipo_batida = false;

          if (!this.model.empregador || this.model.empregador === "") {
            this.error.empregador = true;
          } else this.error.empregador = false;

          if (this.model.funcao !== "" && this.model.departamento !== "" && this.model.tipo_batida !== "" && this.model.empregador !== "") {
            alterarValor(valor);
          }
          break;
        case 4:
          alterarValor(valor);
          break;
        case 5:
          alterarValor(valor);
          break;
      }
    },


  },

  watch: {
    estadoSelecionado(newVal) {
      // this.model.cidade = ""
      let estado = this.estados.filter((dados) => {
        if (dados.ID == newVal) {
          return dados;
        }
      });
      this.model.uf = estado[0].Sigla;

      this.cidades = cidadesjs;

      this.cidades = this.cidades.filter((dados) => {
        if (dados.Estado == newVal) {
          return dados;
        }
      });
    },

    cpf(newVal) {
      if (this.$route.params.typeCad == 1) {
        //create
        if (newVal.length == 14) {
          this.verificarCpf(newVal.replace(/[. - / - -]/g, ""));
        }
      } else if (this.$route.params.typeCad == 2) {
      } //update
    },

    itemMenu(newVal) {
      switch (newVal) {
        case 1:
          this.title = "Dados Pessoais";
          break;
        case 2:
          this.title = "Documentação";
          break;
        case 3:
          this.title = "Dados Empregatícios";
          break;
        case 4:
          this.title = "Contribuição Sindical";
          break;
        case 5:
          this.title = "Foto";
          break;
        default:
          this.title = "";
      }
    },

    nome() {
      this.model.nome = String(this.model.nome).toUpperCase();
    },
    email() {
      this.model.email = String(this.model.email).toLowerCase();
    },
  },

  computed: {
    nome() {
      return this.model.nome;
    },
    email() {
      return this.model.email;
    },
  },
};
</script>
<style>

</style>
